export const setLocalStorageItem = (key: string, value: any): void => {
    try {
      if (key === "details") {
        localStorage.setItem(key, value ? "true" : "false");
      } else if (key === "authToken") {
        localStorage.setItem(key, value);
      } else {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
      }
    } catch (error) {
      console.error(`Error setting localStorage item: ${key}`, error);
    }
  };

  export const getLocalStorageItem = (key: string): any | null => {
    try {
      const storedValue = localStorage.getItem(key);

      if (key === "details") {
        return storedValue === "true";
      }

      if (key === "authToken") {
        return storedValue;
      }

      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error(`Error getting localStorage item: ${key}`, error);
      return null;
    }
  };

  export const clearLocalStorage = (): void => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("Error clearing localStorage:", error);
    }
  };

  // Validation utilities for Indian business formats

export const validatePAN = (pan: string): boolean => {
  // PAN format: AAAAA9999A (5 letters, 4 digits, 1 letter)
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return panRegex.test(pan);
};

export const validateCIN = (cin: string): boolean => {
  // CIN format: L/U + 5 digits + state code + year + PLC/PTC + 6 digits
  const cinRegex = /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;
  return cinRegex.test(cin);
};

export const validateGSTIN = (gstin: string): boolean => {
  // GSTIN format: 15 characters - state code + PAN + entity + check digit
  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  return gstinRegex.test(gstin);
};

export const validateIndianMobile = (mobile: string): boolean => {
  // Indian mobile: starts with 6-9, followed by 9 digits
  const mobileRegex = /^[6-9][0-9]{9}$/;
  return mobileRegex.test(mobile);
};

export const validateBusinessEmail = (email: string): boolean => {
  // Basic email validation with business domain check
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidFormat = emailRegex.test(email);
  
  // Check for common personal email domains (optional strict validation)
  const personalDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com'];
  const domain = email.split('@')[1]?.toLowerCase();
  const isBusinessDomain = !personalDomains.includes(domain);
  
  return isValidFormat; // For now, just check format. Can add business domain check later
};

export const formatPAN = (pan: string): string => {
  return pan.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
};

export const formatCIN = (cin: string): string => {
  return cin.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 21);
};

export const formatGSTIN = (gstin: string): string => {
  return gstin.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 15);
};

export const formatMobile = (mobile: string): string => {
  return mobile.replace(/[^0-9]/g, '').slice(0, 10);
};